import {
  FETCH_INITIAL_DATA_FOR_TAX_BOOKING_ENTITY_MODAL,
  FETCH_INITIAL_DATA_FOR_TAX_BOOKING_ENTITY_MODAL_SUCCESS,
  FETCH_INITIAL_DATA_FOR_TAX_BOOKING_ENTITY_MODAL_FAILURE,
  FETCH_TBE_COMPANY_CODES_FOR_TAX_BOOKING_ENTITY_MODAL,
  FETCH_TBE_COMPANY_CODES_FOR_TAX_BOOKING_ENTITY_MODAL_SUCCESS,
  FETCH_TBE_COMPANY_CODES_FOR_TAX_BOOKING_ENTITY_MODAL_FAILURE,
} from './types';

const initialState = {
  enabledFlagValues: [],
  companyCodes: [],
  tbeCompanyCodes: [],
  importStatus: [],
  usTaxTypeValues: [],
  localTaxTypeValues: [],
  tbeTypeValues: [],
  taxBookingEntityToEdit: null,
  isFetchingInitialDataForModal: false,
  isFetchingTBECompanyCodesForModal: false,
};

function taxBookingEntities(state = initialState, action) {
  switch (action.type) {
    case FETCH_INITIAL_DATA_FOR_TAX_BOOKING_ENTITY_MODAL:
      return {
        ...state,
        isFetchingInitialDataForModal: true,
      };
    case FETCH_INITIAL_DATA_FOR_TAX_BOOKING_ENTITY_MODAL_SUCCESS:
      return {
        ...state,
        enabledFlagValues: action.enabledFlagValues,
        companyCodes: action.companyCodes,
        importStatus: action.importStatus,
        usTaxTypeValues: action.usTaxTypeValues,
        localTaxTypeValues: action.localTaxTypeValues,
        tbeTypeValues: action.tbeTypeValues,
        isFetchingInitialDataForModal: false,
      };
    case FETCH_INITIAL_DATA_FOR_TAX_BOOKING_ENTITY_MODAL_FAILURE:
      return {
        ...state,
        isFetchingInitialDataForModal: false,
      };
    case FETCH_TBE_COMPANY_CODES_FOR_TAX_BOOKING_ENTITY_MODAL:
      return {
        ...state,
        isFetchingTBECompanyCodesForModal: true,
      };
    case FETCH_TBE_COMPANY_CODES_FOR_TAX_BOOKING_ENTITY_MODAL_SUCCESS:
      return {
        tbeCompanyCodes: action.tbeCompanyCodes,
        isFetchingTBECompanyCodesForModal: false,
      };
    case FETCH_TBE_COMPANY_CODES_FOR_TAX_BOOKING_ENTITY_MODAL_FAILURE:
      return {
        ...state,
        isFetchingTBECompanyCodesForModal: false,
      };
    default:
      return state;
  }
}

export default taxBookingEntities;
